
<div class="card card-custom card-stretch gutter-b">
  
    
    <div style="margin-top: 0px !important;    background-color: white;" class="card-header align-items-center border-0 mt-4">
    <!-- <dx-toolbar>
        <dxi-item location="before" widget="dxButton" locateInMenu="auto" [options]="backOptions">
        </dxi-item>
        <dxi-item location="before" widget="dxButton" [options]="saveButtonOptions">
        </dxi-item>
    </dx-toolbar> -->


    <nav  class="toolbar toolbar-icon align-content-center">
        <div class="rounded-pill d-flex align-items-center">
          <a type="button" class="btn btn-hover" routerLink="/microapplication-list">
            <i class="me-1 sidebar-text fa-solid fa-arrow-left"></i>
            <span class="types-custom__letter">Atrás</span>
          </a>
  
          <a style="cursor: pointer;" type="button" class="btn btn-hover" >
            <i style="cursor: pointer;" class="me-1 sidebar-text dx-icon-save" (click)="save()" > <span class="types-custom__letter" style="font-size: large;">Guardar</span></i>           
          </a>

          <!-- <dx-toolbar>
            <dxi-item
              location="before"
              widget="dxButton"
              [options]="addButtonOptions"
            >
            </dxi-item>
          </dx-toolbar> -->
        </div>
    </nav>

    <!-- <ng-container *ngIf="microApps.loadingObserver | async as _loading">
        <span class="spinner spinner-primary ml-5"></span>
    </ng-container> -->
    </div>

    <div class="card-body pt-4">
        
<div id="divMicroApp">
    <dx-form *ngIf="microApploaded | async" [showColonAfterLabel]="false" colCount="4" [elementAttr]="{ id: formId }" [(formData)]="microapplication"
        [showValidationSummary]="true" labelLocation="top">
        <dxi-item dataField="code">
            <dxo-label class="font-weight-bold" text="Código">
            </dxo-label>
            <dxi-validation-rule type="required" [message]="'Código Obligatorio'"></dxi-validation-rule>
        </dxi-item>
        <dxi-item dataField="icon" [template]="'itemIcon'">
            <dxo-label text="Ícono" class="font-weight-bold">
            </dxo-label>
            <dxi-validation-rule type="required" [message]="'Ícono Obligatorio'"></dxi-validation-rule>
        </dxi-item>       
        <div *dxTemplate="let data of 'itemIcon'">
            <dx-drop-down-box #dropDownBoxIcon [(value)]="microapplication.icon" valueExpr="value" [deferRendering]="false"
                placeholder="Seleccionar..." [showClearButton]="true" [dataSource]="gridDataSource">
                <div *dxTemplate="let data of 'content'">
                    <dx-data-grid (onRowClick)="onRowClick($event)" [dataSource]="icons"
                        [selection]="{ mode: 'single' }" [hoverStateEnabled]="true"
                        [paging]="{ enabled: true, pageSize: 10 }" [filterRow]="{ visible: true }"
                        [scrolling]="{ mode: 'infinite' }"  height="100%"
                        [columnAutoWidth]="true" [allowColumnResizing]="true">
                        <dxi-column width="75px" dataField="value" caption="Ícono" cellTemplate="iconCellTemplate">
                        </dxi-column>
                        <div *dxTemplate="let icon of 'iconCellTemplate'">
                            <span>
                                <i [class]="icon.value"></i>
                            </span>
                        </div>
                        <dxi-column dataField="name" caption="Nombre"></dxi-column>
                    </dx-data-grid>
                </div>
            </dx-drop-down-box>
        </div>

        <dxi-item dataField="name" [template]="'itemName'">
            <dxo-label text="Nombre">
            </dxo-label>
            <dxi-validation-rule type="required" [message]="'Nombre Obligatorio'"></dxi-validation-rule>
        </dxi-item>

        <div *dxTemplate="let data of 'itemName'">
            <dx-drop-down-box [(value)]="microapplication.name.esCO" valueExpr="value" [deferRendering]="false"
                placeholder="Seleccionar..." [showClearButton]="true">
                <div *dxTemplate="let data of 'content'">
                    <dx-form [formData]="microapplication.name">

                    </dx-form>
                </div>
            </dx-drop-down-box>
        </div>
        <dxi-item dataField="visible" [template]="'visibleTemplate'">
            <dxi-validation-rule type="required" [message]="'Visible Obligatorio'"></dxi-validation-rule>
        </dxi-item>
        <div *dxTemplate="let visibleData of 'visibleTemplate'">
            <div>
                <dx-switch (onValueChanged)="visibleChanged($event)" [value]="microapplication.visible"></dx-switch>
            </div>

        </div>

        <dxi-item dataField="description">
            <dxo-label text="Descripción" class="font-weight-bold"></dxo-label>
            <dx-drop-down-box [(value)]="microapplication.description.esCO" valueExpr="value" [deferRendering]="false"
                placeholder="Seleccionar..." [showClearButton]="true">
                <dx-form [formData]="microapplication.description">

                </dx-form>
            </dx-drop-down-box>
            <dxi-validation-rule type="required" [message]="'Descripción Obligatoria'"></dxi-validation-rule>
        </dxi-item>

        


        <dxi-item dataField="url">
            <dxi-validation-rule type="required" [message]="'Url Obligatoria'"></dxi-validation-rule>
        </dxi-item>

        <dxi-item dataField="tags" [template]="'tagBoxTemplate'">
            <dxo-label text="Tags">
            </dxo-label>

            <dxi-validation-rule type="required" [message]="'Debe haber al menos un tag'"></dxi-validation-rule>
        </dxi-item>
        <div *dxTemplate="let data of 'tagBoxTemplate'">
            <dx-tag-box [value]="microapplication.tags" (onValueChanged)="setTags($event)" placeholder="Seleccionar..."
                [noDataText]="'Escribe el tag y pulsa enter para agregar nuevas etiquetas'" [acceptCustomValue]="true">

            </dx-tag-box>

        </div>
        <dxi-item dataField="multiInstance" [template]="'multiTemplate'">
            <dxo-label text="Multi Instancia" class="font-weight-bold"></dxo-label>
            <dxi-validation-rule type="required" [message]="'Multi Instancia Obligatorio'"></dxi-validation-rule>
        </dxi-item>
        <div *dxTemplate="let instanceData of 'multiTemplate'">
            <div>
                <dx-switch (onValueChanged)="instanceChanged($event)" [value]="microapplication.multiInstance">
                </dx-switch>
            </div>

        </div>
        <dxi-item dataField="applicationMenu" [template]="'menuTemplate'">
            <!-- <dxi-validation-rule type="required" [message]="'Menú Obligatorio'"></dxi-validation-rule> -->
            <dxo-label text="Menú">
            </dxo-label>
        </dxi-item>
        <dxi-item dataField="type" template="typeTemplate">                
            <dxo-label text="Tipo">
            </dxo-label>
        </dxi-item>

        <div *dxTemplate="let data of 'typeTemplate'">
            <dx-select-box  [value]="microapplication.type"
              (onValueChanged)="microapplication.type = $event.value" valueExpr="id"
              [displayExpr]="'name'" [dataSource]="microApplicationsTypes" placeholder="Seleccione"
              [showClearButton]="true">
            </dx-select-box>
        </div>
        <dxi-item dataField="widgetData">
            <dxo-label text="Widget" class="font-weight-bold"></dxo-label>
            <dx-drop-down-box [(value)]="microapplication.widgetData.order"  valueExpr="value"
                placeholder="Seleccionar..." [showClearButton]="true">
                <dx-form [formData]="microapplication.widgetData">
                    <dxi-item dataField="height">                
                        <dxo-label text="Altura en pixeles">
                        </dxo-label>
                    </dxi-item>
                    <dxi-item dataField="columns" [editorType]="'dxSelectBox'" [editorOptions]="{items:[1,2,3],value:microapplication.widgetData.columns}">                
                        <dxo-label text="Columnas">
                        </dxo-label>
                    </dxi-item>
                    <dxi-item dataField="order" [editorType]="'dxSelectBox'" [editorOptions]="{items:itemsOrder,value:microapplication.widgetData.order}">                
                        <dxo-label text="Orden">
                        </dxo-label>
                    </dxi-item>
                </dx-form>
            </dx-drop-down-box>
            <dxi-validation-rule type="required" [message]="'Descripción Obligatoria'"></dxi-validation-rule>
        </dxi-item>
        <div *dxTemplate="let instanceData of 'menuTemplate'">

            <dx-drop-down-box *ngIf="microapplication.applicationMenu" placeholder="Seleccionar..." #dropDownTreeView  [(value)]="microapplication.applicationMenu.text" valueExpr="id" displayExpr="name" [showClearButton]="true">
                <div *dxTemplate="let data of 'content'">                                                                                                                                
                                <div class="align-items-center border-0 ml-2">
                                    <div class="d-flex flex-column">
                                        <div class="d-flex flex-row">
                                            <div>
                                                <h3>
                                                    <span class="font-weight-bolder text-dark">Menú Principal</span>
                                                  </h3>
                                            </div>
                                            <!-- <div class="pt-11 pl-12">
                                                <ng-container *ngIf="mainService.isLoadingSubject | async">
                                                    <span class="spinner spinner-primary"></span>
                                                  </ng-container>
                                            </div> -->
                                          
                                        </div>
                                          <div class="d-flex flex-row">
                                            <div>
                                              <h3>
                                                <span class="text-muted font-weight-bold font-size-sm"
                                                  >ERP</span
                                                >
                                              </h3>
                                            </div>
                                            <div class="pb-2 ml-auto"><button
                                              to
                                              data-placement="left"
                                              (click)="closeNodes()"
                                              type="button"
                                              class="btn btn-icon btn-light-primary btn-sm"
                                            >
                                              <i class="fas fa-minus-circle"></i>
                                            </button></div>
                                        </div>
                                        
                                      </div>
                                </div>
                                  
                                  
                                  <div>
                                    <div class="dx-treeview-search dx-show-invalid-badge dx-textbox dx-texteditor dx-editor-outlined dx-searchbox dx-show-clear-button dx-texteditor-empty dx-widget">
                                      <div class="dx-texteditor-container">
                                        <div class="dx-texteditor-input-container">
                                          <div class="dx-icon dx-icon-search"></div>
                                          <input (keyup)="handlePropertyChange(buscar.value,$event)" style="font-size: small;" placeholder="Buscar menú"
                                            autocomplete="off" aria-label="Search" class="dx-texteditor-input" type="text" spellcheck="false"
                                            tabindex="0" role="textbox" #buscar>
                                          <div class="dx-placeholder"></div>
                                          <!-- <span id="input_img" class="dx-icon-home icon"></span> -->
                                        </div>
                                      </div>
                                    </div>    
                                    <dx-scroll-view>
                                      <ng-container *ngIf="isSearching; else elseTemplate">
                                        <dx-tree-view style="color: black !important;"  [rootValue]="0" dataStructure="plain"
                                          [createChildren]="createChildren" [noDataText]="'Sin datos'" [searchEnabled]="false" 
                                          itemTemplate="itemTemplate" 
                                          (onItemClick)="onCategoryTreeViewSelectionChanged($event)">
                                          <div *dxTemplate="let itemObj of 'itemTemplate'">
                                            <ng-container *ngIf="itemObj.hasItems">
                                              <span
                                            
                                                cacheSVG="true" class="svg-icon menu-icon"></span>
                                              {{itemObj.text | titlecase}}
                                            </ng-container>
                                            <ng-container *ngIf="!itemObj.hasItems">
                                              <span

                                                cacheSVG="true" class="svg-icon menu-icon"></span>
                                           {{itemObj.text | titlecase}} 
                                            </ng-container>
                                          </div>
                                        </dx-tree-view>
                                      </ng-container>
                                      <ng-template #elseTemplate>
                                        <div *ngFor="let item of mainDataSearch">
                                          <div class="filter">
                                            <span cacheSVG="true" class="svg-icon menu-icon" ></span>
                                            <a  (click)="setMenuBySearch(item)">{{item.text}}</a>
                                          </div>
                                        </div>
                                      </ng-template>
                                    </dx-scroll-view>
                                  </div>
                
                </div>
            </dx-drop-down-box>


        </div>
    </dx-form>

</div>



<!-- <dx-load-panel #loadPanelMicroApp shadingColor="rgba(0,0,0,0.4)" [position]="{ of: '#divMicroApp' }"
    [(visible)]="microApps.loading" [showIndicator]="true" [showPane]="true" [shading]="true" [message]="'Cargando...'"
    [closeOnOutsideClick]="false">
</dx-load-panel> -->






<div id="tabs">
    <ul ngbNav #nav="ngbNav" class="nav-tabs justify-content-left">
        <li ngbNavItem>
            <a ngbNavLink>Parámetros</a>
            <ng-template ngbNavContent>
                <div id="divParameters">
                    <dx-data-grid id="gridParameters" [columnHidingEnabled]="false"
                        [dataSource]="microapplication.parameters"
                        [allowColumnReordering]="true" [allowColumnResizing]="true" [hoverStateEnabled]="true" [columnHidingEnabled]="false"
                        [showColumnLines]="true" [showBorders]="true" [rowAlternationEnabled]="true">
                        <dxo-editing mode="form" [useIcons]="true" [allowUpdating]="true" [allowDeleting]="true"
                            [confirmDelete]="true" [allowAdding]="true">
                            <dxo-texts deleteRow="Borrar fila" addRow="Añadir" cancelAllChanges="Cancelar cambios"
                                editRow="Editar" saveRowChanges="Guardar" cancelRowChanges="Cancelar"
                                confirmDeleteMessage="¿Está seguro de borrar este registro?">
                            </dxo-texts>
                        </dxo-editing>
                        <dxo-export [enabled]="true" fileName="Parámetros" [allowExportSelectedData]="true">
                            <dxo-texts exportAll="Exportar todo" exportSelectedRows="Exportar datos seleccionados" exportToExcel="Exportar a Excel">
                            </dxo-texts>
                        </dxo-export>
                        <dxo-search-panel [visible]="true" [highlightCaseSensitive]="true" [placeholder]="'Buscar'">
                        </dxo-search-panel>
                        <dxo-filter-row [visible]="true"></dxo-filter-row>
                        <dxo-header-filter [visible]="true"></dxo-header-filter>
                        <dxo-selection mode="single"></dxo-selection>
                        <dxo-paging [pageSize]="10"></dxo-paging>
                        <dxo-pager [showPageSizeSelector]="true" [allowedPageSizes]="[5, 10, 20]" [showInfo]="true">
                        </dxo-pager>
                        <dxi-column dataField="code" caption="Código"></dxi-column>
                        <dxi-column dataField="value" caption="Valor"></dxi-column>
                        <dxi-column dataField="type" caption="Tipo">
                            <dxo-lookup [dataSource]="[ {id:0,name:'Valor fijo' },{ id:1,name:'Variable'}]"
                                valueExpr="id" displayExpr="name">
                            </dxo-lookup>
                        </dxi-column>
                    </dx-data-grid>

                    <dx-load-panel #loadPanelParameters shadingColor="rgba(0,0,0,0.4)"
                        [position]="{ of: '#divParameters' }" [(visible)]="microApps.loading" [showIndicator]="true"
                        [showPane]="true" [shading]="true" [message]="'Cargando...'" [closeOnOutsideClick]="false">
                    </dx-load-panel>
                </div>


            </ng-template>
        </li>
        <li ngbNavItem>
            <a ngbNavLink>Acciones</a>
            <ng-template ngbNavContent>

                <div id="divActions">
                    <dx-data-grid id="gridActions" [columnHidingEnabled]="false" [dataSource]="microapplication.actions"
                         [allowColumnReordering]="true"
                        [allowColumnResizing]="true" [hoverStateEnabled]="true" [showColumnLines]="true" [columnHidingEnabled]="false"
                        [showRowLines]="true" [showBorders]="true" [rowAlternationEnabled]="true"
                       >
                        <dxo-editing mode="form" [useIcons]="true" [allowUpdating]="true" [allowDeleting]="true"
                            [confirmDelete]="true" [allowAdding]="true">
                            <dxo-texts deleteRow="Borrar fila" addRow="Añadir" cancelAllChanges="Cancelar cambios"
                                editRow="Editar" saveRowChanges="Guardar" cancelRowChanges="Cancelar"
                                confirmDeleteMessage="¿Está seguro de borrar este registro?">
                            </dxo-texts>
                        </dxo-editing>
                        <dxo-export [enabled]="true" fileName="Acciones" [allowExportSelectedData]="true"></dxo-export>
                        <dxo-search-panel [visible]="true" [highlightCaseSensitive]="true" [placeholder]="'Buscar'">
                        </dxo-search-panel>
                        <dxo-filter-row [visible]="true"></dxo-filter-row>
                        <dxo-header-filter [visible]="true"></dxo-header-filter>
                        <dxo-selection mode="single"></dxo-selection>
                        <dxo-paging [pageSize]="10"></dxo-paging>
                        <dxo-pager [showPageSizeSelector]="true" [allowedPageSizes]="[5, 10, 20]" [showInfo]="true">
                        </dxo-pager>
                        <dxi-column dataField="code" caption="Código"></dxi-column>
                        <dxi-column dataField="name.esCO" caption="Nombre"></dxi-column>
                    </dx-data-grid>                  
                </div>



            </ng-template>
        </li>
    </ul>
    <div [ngbNavOutlet]="nav"></div>
</div>
    </div>
</div>


